import { Card } from '@/components/ui/Card';
import { FlipkartSynopsisMetricValue } from '@/components/flipkart/FlipkartSynopsisMetricValue';
import {
  FLIPKART_SYNOPSIS_METRICS,
  type FlipkartDerivedMetrics,
  type FlipkartSynopsisMetricKey,
} from '@/components/flipkart/flipkartSynopsisMetrics';

const KPI_LABELS: Record<FlipkartSynopsisMetricKey, string> = {
  spend: 'Spend',
  revenue: 'Revenue',
  orders: 'Orders',
  impressions: 'Impressions',
  clicks: 'Clicks',
  ctr: 'CTR',
  cpc: 'CPC',
  cvr: 'CVR',
  acos: 'ACOS',
  roas: 'ROAS',
};

export function FlipkartSynopsisKpis({
  current,
  previous,
  hasPrevious,
}: {
  current: FlipkartDerivedMetrics;
  previous: FlipkartDerivedMetrics;
  hasPrevious: boolean;
}) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {FLIPKART_SYNOPSIS_METRICS.map((metric) => (
        <Card key={metric.key} className="p-4">
          <p className="text-label-md uppercase tracking-[0.08em] text-foreground-subtle">
            {KPI_LABELS[metric.key]}
          </p>
          <div className="mt-2">
            <FlipkartSynopsisMetricValue
              current={current[metric.key]}
              previous={previous[metric.key]}
              hasPrevious={hasPrevious}
              format={metric.format}
              align="start"
              emphasize
            />
          </div>
        </Card>
      ))}
    </div>
  );
}
